export default "__VITE_ASSET__4d678671__"